import React from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ExportToXLSBtn, FilterBox } from '../../../../ui'
import { PAYMENTS_TABLE_COLUMNS, PAYMENTS_TABLE_FILTERS } from '../../constants'
import { usePaymentCalls } from '../../hooks'
import { paymentDataPreparation } from '../../logics'

export const PaymentsHeader = () => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const { getPayments } = usePaymentCalls()
  const paymentsLoader = useSelector((state) => state.loader.payments)

  const selection = paymentsLoader?.selection
  const search = paymentsLoader?.config?.params

  const filters = PAYMENTS_TABLE_FILTERS

  const buttons = (
    <ExportToXLSBtn
      selectedRows={selection}
      columnsExport={PAYMENTS_TABLE_COLUMNS}
      getAllData={() =>
        new Promise((resolve, reject) => {
          getPayments({ params: { ...search, _num_x_pagina: 0 } })
            .then(({ data }) => {
              return resolve(paymentDataPreparation(data.pagos, { intl }))
            })
            .catch((err) => {
              return reject(err)
            })
        })
      }
      titleRoot="payments_"
      headerNamespace="payments"
    />
  )

  const data = filters.map((item, i) => {
    if (item.comboId) {
      item.values = combos[item.comboId] && combos[item.comboId].data
    }
    return {
      ...item,
      label: intl.formatMessage({
        id: 'pages.payments.filters.' + item.name + '.title',
      }),
    }
  })

  return (
    <>
      <FilterBox filters={data}>{buttons}</FilterBox>
    </>
  )
}
